import { render, staticRenderFns } from "./ShiftWireless.vue?vue&type=template&id=79a7b0b6&scoped=true"
import script from "./ShiftWireless.vue?vue&type=script&lang=js"
export * from "./ShiftWireless.vue?vue&type=script&lang=js"
import style0 from "./ShiftWireless.vue?vue&type=style&index=0&id=79a7b0b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a7b0b6",
  null
  
)

export default component.exports